import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { MainLayoutComponent } from './shared/components/main-layout/main-layout.component';
import { FederationShellComponent } from './shared/components/federation-shell/federation-shell.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    component: FederationShellComponent,
    children: [
      // Auth routes
      {
        path: 'federation/auth',
        loadChildren: () =>
          import('./pages/auth/auth.module').then((m) => m.AuthModule),
      },

      // Protected routes
      {
        path: '',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: 'dashboard',
            loadChildren: () =>
              import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
          },
          {
            path: 'federation',
            loadChildren: () =>
              import('./pages/federation/federation.module').then((m) => m.FederationModule),
          },
          {
            path: 'club',
            loadChildren: () =>
              import('./pages/club/club.module').then((m) => m.ClubModule),
          },
          {
            path: 'arbitre',
            loadChildren: () =>
              import('./pages/arbitre/arbitre.module').then((m) => m.ArbitreModule),
          },
          {
            path: 'delegue',
            loadChildren: () =>
              import('./pages/delegue/delegue.module').then((m) => m.DelegueModule),
          },
          { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
        ],
      },

      { path: 'unauthorized', component: UnauthorizedComponent },
      { path: 'no-access', component: UnauthorizedComponent },
      { path: '**', redirectTo: '' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
